<div class="main-container">
  <router-outlet></router-outlet>
</div>
<div class="main-footer">
  <p class="copyright">
    {{ 'common.footer.copyright' | translate }}
  </p>
</div>
